import { axiosInstance as axios, handleAxiosErrors } from '../_utils';
import { buildElasticGraphQLParams } from '../selectors/converterSelector';
import config from '../store/_config';

export const axiosRequestCustomers = (listParams) => {
    let { url, query } = config.customers.listing;
    query = query.replace(/{params}/, buildElasticGraphQLParams(listParams));

    return axios
        .get(url, {
            withCredentials: true,
            params: {
                query: query,
            },
        })
        .catch((error) => {
            handleAxiosErrors(error);
        });
};

export const axiosRequestValidateCustomerEmail = (Email) => {
    let { url, query } = config.customers.validateEmail;
    let variables = {
        Email: Email,

    };
    return axios
        .post(url, {
            withCredentials: true,
                query: query,
                variables: variables,
        })
        .catch((error) => {
            handleAxiosErrors(error);
        });
};

export const axiosRequestCustomer = (id = 0) => {
    let { url, query } = config.customers.detail;
    query = query.replace(/{id}/, id);

    return axios
        .get(url, {
            withCredentials: true,
            params: {
                query: query,
            },
        })
        .catch((error) => {
            handleAxiosErrors(error);
        });
};

export const axiosUpdateCustomers = (memberID, status) => {
    let { url, query } = config.customers.update;

    query = query.replace(
        /{params}/,
        `MemberID: ${memberID}, Status: ${status}`
    );

    return axios.post(
        url,
        { query: query },
        {
            withCredentials: true,
        }
    );
};
export const axiosUpdateCustomerVisibility = (memberID, hidden) => {
    let { url, query } = config.customers.updateVisibility;

    query = query.replace(
        /{params}/,
        `MemberID: ${memberID}, Hidden: ${hidden}`
    );

    return axios.post(
        url,
        { query: query },
        {
            withCredentials: true,
        }
    );
};
